import $ from 'jquery';

import LangSelector from './components/lang-selector';
import SiteHeader from './components/site-header';
// import HomeSlider from "./components/home-slider";
// import NewsSlider from "./components/news-slider";
import FormationsSlider from './components/formations-slider';
// import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from './components/partners-slider';
import CarouselSlider from './components/carousel-slider';
import HandheldMenu from './components/handheld-menu';
import DropdownMenu from './components/dropdown-menu';
import Accordion from './components/accordion';
import Gallery from './components/gallery';
import NewsletterForm from './components/newsletter-form';
import ScrollInView from './components/scroll-in-view';
import Modal from './components/modal';
import SearchToggler from './components/search-toggler';
import CardsCarousel from './components/cards-carousel';
import CardsCarouselBis from './components/cards-carousel-bis';
import LogosSlider from './components/logos-carousel';
import NewsThumbnail from './components/news-thumbnail';
import ContactPage from './components/contact-page';
import Tabs from './components/tabs';
import ScrollAnchor from './components/scroll-anchor';

import DeviceManager from './utils/device-manager';

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $('html');

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass('touch');

      if (DeviceManager.isIos()) {
        $html.addClass('ios');
      }
    } else {
      $html.addClass('no-touch');
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass('ie11');
    } else if (DeviceManager.isEdge()) {
      $html.addClass('edge');
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($('.language-selector'));
    const siteHeader = new SiteHeader($('.site-header'), 20);

    // Cards slider component
    const $cardsCarousels = $('.card-slider-section .cards-carousel');
    if ($cardsCarousels.length) {
      $cardsCarousels.each(function (index, el) {
        const cardsCarousel = new CardsCarousel($(el));
      });
    }

    // Cards slider component
    const $cardsCarouselsBis = $('.card-slider-gray-section .cards-carousel');
    if ($cardsCarouselsBis.length) {
      $cardsCarouselsBis.each(function (index, el) {
        const cardsCarouselBis = new CardsCarouselBis($(el));
      });
    }

    // Carousel slider component
    const $carouselSliders = $('.carousel');
    if ($carouselSliders.length) {
      $carouselSliders.each(function (index, el) {
        const carouselSlider = new CarouselSlider($(el));
      });
    }

    // Formations slider component
    const $formationsSliders = $('.formations-slider');
    if ($formationsSliders.length) {
      $formationsSliders.each(function (index, el) {
        const formationSlider = new FormationsSlider($(el));
      });
    }

    // Partners slider component
    const $partnersSliders = $('.partners-slider');
    if ($partnersSliders.length) {
      $partnersSliders.each(function (index, el) {
        const partnerSlider = new PartnersSlider($(el));
      });
    }

    // logos-carousel
    const $logosSliders = $('.page .logos-carousel');
    if ($logosSliders.length) {
      $logosSliders.each(function (index, el) {
        const logoSlider = new LogosSlider($(el));
      });
    }

    // Newsletter form component
    const $newsletterFormElements = $('.footer-block.footer-block--newsletter-style');
    if ($newsletterFormElements.length) {
      $newsletterFormElements.each(function (index, el) {
        const newsletterForm = new NewsletterForm(el);
      });
    }

    // Scroll in view component
    const $scrollInViewElements = $('.scroll-in-view');
    if ($scrollInViewElements.length) {
      $scrollInViewElements.imagesLoaded(function () {
        const scrollInView = new ScrollInView($scrollInViewElements);
      });
    }
  };

  bootstrapApp();
  instanciateComponents();
});

const url = new URL(window.location.href);

if (url.searchParams.size > 0) {
  const target = document.querySelector('.archive-layout__right');

  if (target) {
    const offset = 192;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top, behavior: 'smooth' });
  }
}

const calendarToggler = document.querySelector('#calendar-toggler');
const calendarContainer = document.querySelector('#calendar-container');

if (calendarToggler && calendarContainer) {
  calendarToggler.addEventListener('click', () => {
    calendarContainer.classList.toggle('calendar-container--opened');
    calendarToggler.classList.toggle('calendar-toggler--opened');
  });
}
// })(jQuery);
